import endpoints from '@app/src/api/endpoints'
import { FetchKey, useFetchPost } from '@app/src/api/fetchHooks'
import {
  OrganizationRecommendationRequest,
  RecommendationResult,
  RecommendationTypeName,
} from '@app/src/types/resourceExplorer'

interface UseOrganizationRecommendationsProps {
  recommendationTypeNames?: RecommendationTypeName[]
  progressTrackerId?: number
  enabled?: boolean
}

const useOrganizationRecommendations = ({
  progressTrackerId,
  recommendationTypeNames = [],
  enabled = true,
}: UseOrganizationRecommendationsProps) => {
  return useFetchPost<RecommendationResult[], OrganizationRecommendationRequest>({
    key: [FetchKey.OrganizationRecommendations, progressTrackerId, ...recommendationTypeNames],
    endpoint: endpoints.organizationRecommendations,
    payload: {
      progressTrackerId: progressTrackerId ?? 0,
      recommendationTypeNames,
    },
    options: {
      enabled: enabled && Boolean(progressTrackerId),
      staleTime: 60000,
    },
  })
}

export default useOrganizationRecommendations
